import React, {FunctionComponent} from "react";
import {ActionFieldProps} from "../../features/actions/common/commonTypes";
import {SubtleTextbox, harvestErrors} from "./SubtleTextBox";
import Textbox from "./TextBox";

const PasswordInput: FunctionComponent<ActionFieldProps> = (
    {
        formState,
        resetField,
        validatingRegister,
        mutationResults
    }
) => {
    return <Textbox
        error={formState.errors.password}
        style={{
            height: '50px',
            width: '100%',
            marginBottom: '2px'
        }}
        labelText="Password"
        type="password"
        autoComplete="current-password"
        {...validatingRegister('password', {
            required: {
                value: true,
                message: 'Password is required',
            },
        })}
    />;
}

export default PasswordInput;
